/**
 * Total room time limit in milliseconds (2 hours and 10 minutes = 130 minutes).
 */
export const ROOM_TIME_LIMIT_MS = 130 * 60 * 1000;
/**
 * Warning threshold: show warning when 10 minutes remain.
 */
export const ROOM_TIME_WARNING_REMAINING_MS = 10 * 60 * 1000;
/**
 * Notification UID for the room time limit warning.
 */
export const ROOM_TIME_LIMIT_WARNING_NOTIFICATION_UID = 'ROOM_TIME_LIMIT_WARNING';
